import React from 'react';
import Skeleton from 'react-loading-skeleton';
// import {recurrenceType} from '../../utils';

export default function Data(props) {
    return (

        <div className="card shadow">
            <div className="card-body">
                <h4 className="card-title text-dark">Detalhes da sua compra</h4>
                <div className="card" >
                    <ul className="list-group list-group-flush">


                        <li className="list-group-item text-dark">{
                            props.loading ? (
                                <Skeleton width={300} />
                            ) : "Identificador: " + props.titulo
                        }
                        </li>


                        <li className="list-group-item text-dark">
                            {
                                props.loading ? (
                                    <Skeleton width={200} />
                                ) : "Valor total: " + props.valor_pagamento
                            }
                        </li>
                        <li className="list-group-item text-dark">
                            {
                                props.loading ? (
                                    <Skeleton width={250} />
                                ) : "Nº de parcelas: " + props.parcelas
                            }
                        </li>
                        <li className="list-group-item text-dark">
                            {
                                props.loading ? (
                                    <Skeleton width={250} />
                                ) : "Valor por parcela: " + props.valor_por_parcela
                            }

                        </li>
                        <li className="list-group-item text-dark">
                            {
                                props.loading ? (
                                    <Skeleton width={250} />
                                ) : <span>{"Descrição dos bens e/ou serviços adquiridos: " } <br /><br /> {(props.descricao_cliente || "")}</span>
                            }

                        </li>
                        {/*Recorrencia fora do escopo*/}
                        {/* <li className="list-group-item text-dark">
                            {
                                props.loading ? (
                                    <Skeleton width={250} />
                                ) : "Venda recorrente: " + (props.recurrent_payment ? "Sim" : "Não")
                            }

                        </li>

                        <li className="list-group-item text-dark">
                            {
                                props.loading ? (
                                    <Skeleton width={250} />
                                ) : "Tipo da recorrência: " + recurrenceType(props.recurrence_type)
                            }

                        </li> */}

                    </ul>
                </div>
            </div>
        </div>
    )
}
